











































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import {IEditor, Editor,CustomDirectEditProvider} from '@/agiles/common/validator';

// import { SettlementTypes } from '../../models/All';
// import { ReturnDeliveryQuery } from '../../models/All';

@Component
export default class AloneInvoiceView extends Vue {
  public items: Common.Invoice[] = new Array(0);
  public params: Common.PurchaseInvoiceQuery = new Common.PurchaseInvoiceQuery();
  public exportQuery = new Common.InvoiceExportQuery('仕入計上',this.params,false,Common.SalesPurchaseFlags.Purchase);
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'invoiceNo', text: '入荷番号' },
    { value: 'refNo', text: '入荷管理番号' },
    { value: 'segment', text: '部門' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'closingDate', text: '仕入日' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;  
  public invoiceStatus = Common.InvoiceStatus;  
  @Prop() public invoiceNo:string;
  
  public tabVisibles: boolean[] = null;
  public editorDecimal: number = 0;
  // 一覧可変表示用プロパティ
  public hasLicenseCurrency: boolean = false;  
  public hasLicenseImport: boolean = false;  
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  // 支払情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');

  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    
    // 検索条件を設定する
    if(this.invoiceNo) {
      this.params.invoiceNo = this.invoiceNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseImport = this.$api.hasLicense(Common.licenseFlags.import);    
    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('入荷番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 170),
      new Common.GridItemConfiguration('仕入日', 100),
      new Common.GridItemConfiguration('仕入先', 180),
      new Common.GridItemConfiguration('取引通貨', 100,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('買掛金額', 120),      
      new Common.GridItemConfiguration('計上レート', 120,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('支払予定日', 100),
      // new Common.GridItemConfiguration('請求締', 100),      
      new Common.GridItemConfiguration('計上区分', 150),      
      // new Common.GridItemConfiguration('決済条件', 150),      
      new Common.GridItemConfiguration('決済方法', 150),      
      new Common.GridItemConfiguration('現金口座', 150),      
      new Common.GridItemConfiguration('手数料額', 150),            
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('入荷管理番号', 150),
      // new Common.GridItemConfiguration('税計算区分', 150),
      new Common.GridItemConfiguration('支払額', 150),
      new Common.GridItemConfiguration('買掛金残高', 150),      
      new Common.GridItemConfiguration('税抜金額', 150),
      new Common.GridItemConfiguration('消費税額', 150),
      new Common.GridItemConfiguration('計上金額', 150),
      new Common.GridItemConfiguration('計上税額', 150),
      new Common.GridItemConfiguration('税込計上額', 150),            
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    this.paymentTabGridConfig.setGridItems(
      new Common.GridItemConfiguration('支払伝票番号', 150),
      new Common.GridItemConfiguration('消込', 120),
      new Common.GridItemConfiguration('支払日', 120),
      new Common.GridItemConfiguration('支払通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('支払レート', 150,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('支払額', 150),
      new Common.GridItemConfiguration('支払計上額', 150,this.hasLicenseCurrency),      
    );
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;
 
    if (this.hasLicenseImport) this.tabVisibles = [true,true,true,true,true,true,];
    else this.tabVisibles = [true,true,true,true,true,true,];　 //スタンダードでも前受金タブを表示
    
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
  }

  public async onCreate(obj: Common.Invoice) {
    const workflows = this.$api.formatter.getOptions('workflow_purchaseInvoice');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public async onDelete(){
    var selectedItems =  (this.$refs.mainList as Components.ListView).selectedItems;
    return this.$api.modal.showDialog('確認メッセージ', selectedItems.length + '件のデータを本当に削除してよろしいですか?', false)
        .then(() => {
          this.$api.startWaitCusor();
          return this.$api.execute(new Common.InvoiceDeleteQuery(selectedItems)).finally(()=>this.$api.closeWaitCursor());
        }); //更新処理エラーは握り潰してリスト更新を実行させる必要がある。
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //入荷明細タブのリロード
    (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  public get workflowRequired() {
    return this.$api.formatter.getOptions('workflow_purchaseInvoice').length != 0;
  }

  public isEditable(settlement: Common.SettlementTypes): boolean{
    return settlement == Common.SettlementTypes.ByCash;
  }

  public isEditableState(state: Common.InvoiceStatus):boolean{
    return state == Common.InvoiceStatus.PurchasePostWaiting;
  }
  // 未着品計上の場合有効
  public isEditableInvoiceType(state: Common.InvoiceTypes):boolean{
    return state == Common.InvoiceTypes.PurchaseTransit;
  }

  // 決済方法が売掛に変更された場合、入金予定日を設定する
  public onChangeSettlement(item: Common.Invoice){
    if(item.settlement == Common.SettlementTypes.ByPayable) item.dueDate = item.counterpart.getPaymentDate(new Date(item.closingDate), this.tenantSettings);
  }

  // 一覧でチェックされている請求
  public checkedInvoices: Array<Common.Invoice>= new Array(0);
  public getCheckedInvoices(){
    this.checkedInvoices = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedInvoices.push(obj);
      }
    });
  }

  // 支払処理用プロパティ
  public brSegment: Common.Segment = null;
  public brPic: string = '';
  public brWorkflowId:number =0;
  public brCounterpart: Common.Counterpart = null;
  public brCurrencyCode: string = '';
  public brReceiptDate: Date = new Date;
  public brBankAccount: Common.BankAccount = null;
  public brDescription: string = '';
  public brExchangeRate:number = 0;
  public brDecimal: number = 0;
  public get brReceiptAmountFC(): number { 
    return this.brSettlementAmountFC + this.brCommissionAmountFC; 
    };
  public brCommissionAmountFC: number = 0;
  public brCommissionTaxFlag: boolean = false;
  public get brSettlementAmountFC(): number {
    if(this.checkedInvoices.length == 0) return 0;
    return this.checkedInvoices.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public brMin(invoice:Common.Invoice): number{
    if(invoice.pendingBalanceAmountFC > 0) return 0;
    else return invoice.pendingBalanceAmountFC;
  }
  public brMax(invoice:Common.Invoice): number{
    if(invoice.pendingBalanceAmountFC < 0) return 0;
    else return invoice.pendingBalanceAmountFC;
  }
  public showBilledReceiptDialog2() {
    this.checkedInvoices = new Array(0);
    this.checkedInvoices.push(this.selectedInvoice);
    this.showBilledReceiptDialogExec();
  }
  // 支払ダイアログの表示
  public showBilledReceiptDialog() {
    this.getCheckedInvoices();

    // ダイアログ表示前バリデーション
    if(this.checkedInvoices.length == 0){
      this.$api.modal.show('', '対象の伝票を選択して下さい。', true, null);            
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.counterpart.id != this.checkedInvoices[0].counterpart.id)).length > 0){
      this.$api.modal.show('', '仕入先の異なる仕入データを、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.currencyCode != this.checkedInvoices[0].currencyCode)).length > 0){
      this.$api.modal.show('', '取引通貨の異なる仕入データを、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> (invoice.segmentId != this.checkedInvoices[0].segmentId)).length > 0){
      this.$api.modal.show('', '部門の異なる仕入データを、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }    
    // if(this.checkedInvoices.filter(invoice=> (invoice.purchaseCurrentAmountFC == 0)).length > 0){
    //   this.$api.modal.show('', '買掛金残高のある請求データを選択して下さい。', true, null);
    //   return;
    // }
    if(this.checkedInvoices.filter(invoice=> (invoice.state & (Common.InvoiceStatus.PurchasePaymentWaiting | Common.InvoiceStatus.PurchasePaying)) == Common.InvoiceStatus.Purchase).length > 0){
      this.$api.modal.show('', '支払処理待ち・支払処理中の伝票を選択してください。', true, null);
      return;
    }    
    if(this.checkedInvoices.filter(invoice=> (invoice.state & Common.InvoiceStatus.PurchaseCompletedAll) > Common.InvoiceStatus.Purchase).length > 0){
      this.$api.modal.show('', '支払は完了しています。', true, null);
      return;
    }
    if(this.checkedInvoices.filter(invoice=> invoice.settlement == Common.SettlementTypes.ByCash).length > 0){
      this.$api.modal.show('', '支払は完了しています。', true, null);
      return;
    }

    this.showBilledReceiptDialogExec();
  }
  public showBilledReceiptDialogExec() {
    // プロパティの初期化
    this.brSegment = this.checkedInvoices[0].segment; //請求部門をセット(非表示)
    this.brPic = this.$api.auth.userId;    
    this.brWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_sendPayment');
    this.brCounterpart =  this.checkedInvoices[0].counterpart.payee ? this.checkedInvoices[0].counterpart.payee : this.checkedInvoices[0].counterpart;
    this.brCurrencyCode = this.checkedInvoices[0].currencyCode;
    this.brReceiptDate = this.checkedInvoices.map(invoice => invoice.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.brCommissionAmountFC = 0;
    this.brCommissionTaxFlag = true; // 販売管理では課税固定
    this.brExchangeRate = 1;
    this.onChangeReceiptDate();
    this.getBankAccount();
    this.checkedInvoices.forEach((obj) => {
      obj.writeoffAmountFC = obj.pendingBalanceAmountFC
    });
    this.onBilledReceiptChangeWorkflow();

    this.brDecimal = 0;
    const obj = this.$api.currencies.filter(obj => obj.value == this.brCurrencyCode);
    if (obj.length > 0) this.brDecimal = Number(obj[0].text);

    // ダイアログの表示
    (this.$refs.billedReceiptDialog as Components.ListDialog).items = this.checkedInvoices;
    (this.$refs.billedReceiptDialog as Components.ListDialog).showDialog();
  }
  public onBilledReceiptChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("支払保存");
    if(this.brWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('sendPayment', this.brWorkflowId, Common.PaymentStatus.PaymentPostWaiting);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }

  public async onChangeReceiptDate(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.brCurrencyCode;
    query.startDate = this.brReceiptDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.brExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

  public async getBankAccount(){
    const query = new Common.GetBankAccount();
    query.currencyCode = this.brCurrencyCode;
    this.$api.execute(query).then(res => {
      this.brBankAccount = res as Common.BankAccount;
    });
  }

  // 支払処理の実行
  public async submitBilledReceipt(list: Array<Common.Invoice>, index:number) {
    // 実行前バリデーション
    // if(this.brSettlementAmountFC != list.map(invoice => invoice.writeoffAmountFC).reduce((total, value) => total += value)){
    //   this.$api.modal.show('', '支払額合計が決済金額となるように入力してください。', true, null);
    //   return;
    // }
    // if(list.filter(invoice => invoice.currencyCode != this.tenantSettings.currencyCode && invoice.billedBalanceAmountFC < invoice.writeoffAmountFC).length > 0){
    //   this.$api.modal.show('', '売掛金残高を超える入金は、システム通貨のみ可能です。', true, null);
    //   return;
    // }
    
    // クエリの設定
    var query = new Common.BilledReceiptQuery();
    query.isCarryOverInvoice = false;
    query.salesPurchaseFlag = Common.SalesPurchaseFlags.Purchase;
    query.segment = this.brSegment;
    query.pic = this.brPic;
    query.workflowId = this.brWorkflowId;
    query.counterpart = this.brCounterpart;
    query.currencyCode = this.brCurrencyCode;
    query.receiptDate = this.brReceiptDate;
    query.bankAccount = this.brBankAccount;
    query.description = this.brDescription;
    query.exchangeRate = this.brExchangeRate;
    query.commissionAmountFC = this.brCommissionAmountFC;
    query.settlementAmountFC = this.brSettlementAmountFC;
    query.commissionTaxFlag = this.brCommissionTaxFlag;
    query.invoices = list;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    // 入金処理の実行
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/cash/Deposit?paymentNo={0}', (res as Common.Payment).paymentNo));
    // });

    return this.$api.execute(query,true).then(res => {
      //リストリロード & 入金明細タブのリロード
      (this.$refs.mainList as Components.ListView).reload().then(()=>this.refreshPaymentList());
      var payment = res as Common.Payment;
      // this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))]);
      this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',false,()=>this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo)),[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))],'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});        
  }

  // 入金情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPendingAmountFC:number = 0;
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 一覧選択時に入金情報・前受金適用額一覧タブを更新
  public selectedInvoice: Common.Invoice;
  public onSelectedMain(index: number, selected: Common.Invoice) {

    const obj = this.$api.currencies.filter(obj => obj.value == selected.currencyCode);
    if (obj.length == 0) this.editorDecimal = 0;
    else this.editorDecimal = Number(obj[0].text);

    this.selectedInvoice = selected;
    // 入金情報タブを更新
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;        
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
    
    // 前受金適用額一覧タブを更新
    this.advanceWriteoffamountFC = 0;
    this.advanceJournals = new Array(0);
    if(index >= 0) this.refreshAdvanceWriteoffList();
  }

  // 入金情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffPendingAmountFC = 0;        
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = this.selectedInvoice.invoiceNo;
    query.isSend = true;

    // サーバーから入金情報を取得する
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.paymentJournals = res.result;
      this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentPostWaiting;            
          }
      });
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;      
    });
  }

  // 入金一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',paymentNo));
  }
  //伝票へ遷移する
  public onOrderNoClick(orderNo: string){
    if (orderNo.startsWith("SO")) this.$router.push(String.format('/purchase/PurchaseOrder?orderNo={0}',orderNo));
    else this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',orderNo));
  }
  // 前受金適用額一覧タブ更新用プロパティ
  public advanceWriteoffamountFC:number = 0;
  public advanceJournals: Common.TransferJournal[]= new Array(0);

  // 前受金適用額一覧タブを更新
  public refreshAdvanceWriteoffList(){this.isLoading = true;
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;

    // クエリの設定
    var query = new Common.AdvanceJouralQuery();
    query.invoice = this.selectedInvoice;

    // サーバーから前受金適用額を取得する
    this.$api.execute(query).then(res => {
      res = res as Common.LoadResult;
      this.advanceJournals = res.result;
      this.advanceJournals.forEach((obj, index) => {
        totalWriteoffAmountFC += obj.amountFC;
      });
    }).finally(()=>{
      this.isLoading = false;
      this.advanceWriteoffamountFC = totalWriteoffAmountFC;
    });
  }

  // 受注伝票選択一覧ダイアログ用プロパティ
  public awaCounterpartName: string = '';
  public awaCounterpart: Common.Counterpart = null;
  // 受注伝票選択一覧ダイアログの表示
  public showAdvanceWriteoffAddDialog() {
    if (this.selectedInvoice != null)
    {
      this.isLoading = true;
      // this.awaCounterpartName = this.selectedInvoice.counterpart.name;
      this.awaCounterpart = this.selectedInvoice.counterpart;
      this.$api.execute(new Common.AdvanceBalanceQuery(this.selectedInvoice.counterpart.id,Common.SalesPurchaseFlags.Purchase)).then(res => {
        (this.$refs.advanceWriteoffAddDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
        (this.$refs.advanceWriteoffAddDialog as Components.ListDialog).showDialog();
      })
      .finally(()=>{
        this.isLoading = false;
      });
    }
  }

  // 前受金追加の実行
  public async submitAdvanceWriteoffAdd(list: Array<Common.Order>) {
    
    if (list.filter(obj =>obj.writeoffAmountFC != 0).length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','前払金消込額を指定してください。').then(()=>{return false;});      
    }

    this.isLoading = true;
    // クエリの設定
    var query = new Common.AdvanceWriteoffAddQuery();
    query.invoice = this.selectedInvoice;
    query.orders = list;

    // 前受金追加の実行
    await this.$api.execute(query).then(res => {
      // 前受金適用額一覧を更新
      this.refreshAdvanceWriteoffList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  // 前受金削除の実行
  public submitAdvanceWriteoffDelete() {
    // 前受金消込が0件の場合は、何もしない
    var journals:Array<any> = (this.$refs.advanceWriteoffListBox as Components.Grid).items;
    if(journals.length == 0) return;

    // 選択している前払金消込の取得
    var selectedId = (this.$refs.advanceWriteoffListBox as Components.Grid).selectedId;
    var journal = journals[selectedId];

    // クエリの設定
    var query = new Common.AdvanceWriteoffDeleteQuery();
    query.transferJournal = journal;

    // 前受金削除の実行
    this.isLoading = true;
    this.$api.execute(query).then(res =>{
      // 前受金適用額一覧を更新
      this.refreshAdvanceWriteoffList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  // 前受金追加・削除ボタン活性制御
  public disabledAdvanceWriteoff():boolean{
    return this.isLoading || this.selectedInvoice.state >= Common.InvoiceStatus.PurchasePaymentWaiting;
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.Invoice){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseInvoice, sourceNo : item.invoiceNo},this.$el);
  }

  // 請求明細一覧へ遷移する
  public showInvoiceItem(invoiceNo: string) {
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseDeliveryItem?invoiceNo={0}', invoiceNo));
    window.open(routeData.href, '_blank');
  }

 //******* 前払金消込  *********/
 //消込明細のダイレクトエディットサポートをするためのエディタ
  public originalJournals: Array<Common.TransferJournal> = null;
  public getJournalEditor(){

    var listView = this.$refs.mainList as Components.ListView;
    var editor = new Editor();
    editor.isEdit = false;
    editor.owner = new CustomDirectEditProvider();
    editor.owner.onDirectEdit = () => {
      this.originalJournals = this.advanceJournals;
      this.advanceJournals = this.$api.createBinder('TransferJournal',true).loadInstance(this.originalJournals);
    };    
    editor.owner.onDirectCommit = () => {
        var items = this.advanceJournals.filter((obj,index) => obj.amountFC != this.originalJournals[index].amountFC);
        this.$api.execute(new Common.InvoiceJournalUpdateQuery(listView.selected, false, items))
        .then(res =>{this.$set(this.items, listView.currentId, res);})
        .catch(res => {this.advanceJournals = this.originalJournals;});        //エラーが出た場合は元戻し
    };
    editor.owner.onDirectClose = () =>{
      //ロールバック
      this.advanceJournals = this.originalJournals;
    }; 
    editor.owner.hasDirectPerm = () => {
      var editable = listView.selected.state == Common.InvoiceStatus.PurchasePostWaiting;
      return editable && this.$api.perms.hasWorkflowPermission(listView.selected.workflowHolder);
    };    

    return editor;
  }

  public showWriteoffDialog(item: Common.Invoice){

    this.$api.execute(new Common.InvoiceJournalTargetQuery(item)).then(res=>{
      var dialog = this.$refs.writeoffDialog as Components.ListDialog;
      dialog.items = res as Array<Common.TransferJournal>;
      dialog.showDialog();
    });
  }
  public async submitWriteoffDialog(list: Array<Common.TransferJournal>){
    // 実行前バリデーション
    var items = list.filter(obj =>obj.amountFC !=0);
    if(items.length ==0){
      this.$api.modal.show('', '前払金額を指定してください。', true, null);
      return;
    }    
    var listView = this.$refs.mainList as Components.ListView;
    this.$api.execute(new Common.InvoiceJournalUpdateQuery(listView.selected, false, items)).then(res =>{
      this.$set(this.items, listView.currentId, res);
    });
  }
  //入金削除
  public submitWriteoffDelete(){
      var listView = this.$refs.mainList as Components.ListView;
      var items = (this.$refs.advanceWriteoffListBox as Components.Grid).selectedItems;
      if (items.length == 0) {
        this.$api.modal.show('無効な操作','削除対象を選択してください。',true,null);
        return;
      }

      this.$api.modal.showDialog('確認メッセージ',String.format('{0}件の{1}を削除してよろしいですか？',items.length, '前払金'),false).then(()=>{
        this.$api.execute(new Common.InvoiceJournalUpdateQuery(listView.selected, true, items)).then(res =>{
          this.$set(this.items, listView.currentId, res);
        });        
      });
  }






}
